<template>
    <div class="publish-filter-flex-container-outer"
         @click="$emit('click')">

        <div class="publish-filter-flex-container">
            <dropdown-popper-wrapper
                :vuetify-component-ref-get="() => $refs.dropdownScreengroups">
                <template #default="{ attachGet, menuProps }">
                    <v-autocomplete
                        ref="dropdownScreengroups"
                        :aria-label="t_screengroups"
                        :attach="attachGet()"
                        :items="screensData.screengroups"
                        :menuProps="menuProps"
                        :prefix="t_screengroups + (filters.screengroup == '' ? '' : ':')"
                        :value="filters.screengroup"
                        class="input-clearable-floating"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        @input="onScreengroupInput" />
                </template>
            </dropdown-popper-wrapper>

            <dropdown-popper-wrapper
                :vuetify-component-ref-get="() => $refs.dropdownScreens">
                <template #default="{ attachGet, menuProps }">
                    <v-autocomplete
                        ref="dropdownScreens"
                        :aria-label="t_screens"
                        :attach="attachGet()"
                        :items="selectableScreens"
                        :menuProps="menuProps"
                        :prefix="t_screens + (filters.screen == '' ? '' : ':')"
                        :value="filters.screen"
                        class="input-clearable-floating"
                        clearable
                        dense
                        hide-details="auto"
                        outlined
                        @input="filters.screen = $event ?? ''" />
                </template>
            </dropdown-popper-wrapper>
        </div>
        <div class="publish-filter-flex-container-label">
            <datepicker :label="t_valid_from"
                        :max="filters.validTo"
                        :value="filters.validFrom"
                        hide-details
                        outlined
                        @input="filters.validFrom = $event ?? ''" />

            <datepicker :label="t_valid_to"
                        :min="filters.validFrom"
                        :value="filters.validTo"
                        align-right
                        hide-details
                        outlined
                        @input="filters.validTo = $event ?? ''" />
        </div>
    </div>
</template>

<script>
import datepicker from '../../common/datepicker.vue'
import '../../../../prototypeExtensions/String'
import DropdownPopperWrapper from '../../common/dropdown-popper-wrapper.vue';

export default {
    props: {
        /** @type {ScreensData} */
        screensData: Object,
        preserveDateFilters: Boolean,
        attachDropdowns: Boolean
    },
    components: {
        DropdownPopperWrapper,
        datepicker
    },
    data() {
        return {
            /** @type {PublishFilters} */
            filters: {
                screen: '',
                screengroup: '',
                validFrom: '',
                validTo: ''
            },

            selectableScreens: [],

            t_screens: Lang.langChoice('Screen|Screens', 1),
            t_screengroups: Lang.langChoice('Screengroup|Screengroups', 1),
            t_valid_from: Lang.langGet('from').capitalize(),
            t_valid_to: Lang.langGet('to').capitalize()
        }
    },
    computed: {
        localStorageKey() {
            return `publish-filter.${Laravel.activeUser}.${Laravel.activeProject}`
        }
    },
    methods: {
        onScreengroupInput(screengroup) {
            this.selectableScreens = this.getSelectableScreens(screengroup)

            if (!this.selectableScreens.find(selectableScreen => selectableScreen.value == this.filters.screen))
                this.filters.screen = ''

            this.filters.screengroup = screengroup ?? ''
        },
        getSelectableScreens(screengroup) {
            // screengroup is "1", "0", "24" etc, or '' if empty
            return !screengroup && screengroup != 0 ? this.screensData.screens : this.screensData.screens.filter(data => this.screensData.screengroupsToScreens[screengroup]?.includes(Number(data.value)))
        }
    },
    watch: {
        filters: {
            handler(val) {
                this.$emit('input', val)
                EaseEventBus.fire('filterLayer', val)
                localStorage.setItem(this.localStorageKey, JSON.stringify(val))
            },
            deep: true
        }
    },
    created() {
        /** @type {PublishFilters} */
        let filters = JSON.parse(localStorage.getItem(this.localStorageKey))
        if (filters !== null) {

            // Upgrade from old property name
            if (filters.valid_to) {
                filters.validTo = filters.valid_to
                delete filters.valid_to
            }
            if (filters.valid_from) {
                filters.validFrom = filters.valid_from
                delete filters.valid_from
            }

            if (!this.preserveDateFilters) {
                filters.validTo = ''
                filters.validFrom = ''
                EaseEventBus.fire('publishFilterMounted')
            }

            if (!this.screensData.screengroups.map(x => x.value).includes(filters.screengroup)) {
                filters.screengroup = this.screensData.default_screengroup.toString()
            }
            if (!this.screensData.screens.map(x => x.value).includes(filters.screen)) {
                filters.screen = ''
            }
            if (this.screensData.screengroupsToScreens[filters.screengroup] && !this.screensData.screengroupsToScreens[filters.screengroup].includes(Number(filters.screen))) {
                filters.screen = ''
            }
        } else {
            filters = {
                screen: '',
                screengroup: this.screensData.default_screengroup,
                validFrom: '',
                validTo: ''
            }
        }
        this.selectableScreens = this.getSelectableScreens(filters.screengroup)
        this.filters = filters
    }
}
</script>

<style>
.publish-filter-flex-container-outer {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 16px;
    align-items: stretch;
    width: 100%;
}

.publish-filter-flex-container-label {
    display: flex;
    flex-direction: row;
    gap: 12px 8px;
    align-items: stretch;
    flex-grow: 1;
    flex-basis: 306px;
}

.publish-filter-flex-container {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: stretch;
    width: 100%;
    flex-basis: 480px;
    flex-grow: 9999;
}

</style>
